const EMPTY_OBJECT = Object.freeze({});

export default EMPTY_OBJECT;
